var fixed_gift_id = parseInt($('#_getCartGiftWrap').attr('data-vid'));
var gift_url;

var addCartArray = [];
var addCartMessageArray = [];
var totalGiftTobeWrap;

var editCartArray = [];
var isEdit = false;
var isAddGift = false;

var number_of_gift_wrap;
var __qtys = 0;

$(function(){
  masterGiftBox(); 
});

masterGiftBox = () => {
  checkGiftWrapCurr();
  giftBoxesItemsStatus();
}

giftBoxesItemsStatus = () => {
  var $itemsArr = [];
    $.when($.getJSON('/cart.js', function(cart) {
      $cartItems = cart.items;

  })).then(function(){
    
    for (var i = 0; i < $cartItems.length; i++) {       
        var $product = $cartItems[i].product_title;
        var $variant = $cartItems[i].variant_title;

        if ($variant != null){
         var $prodPlusVar = $product+' - '+$variant;
        }else{
          var $prodPlusVar = $product; 
        }

        $itemsArr.push($prodPlusVar);          
    }

    hideShowGiftError($itemsArr);

  });

}

editGiftsLink = () => {
  var editGiftsButton = $('#giftwrap_1 .edit_btn');
  if (editGiftsButton !== null) {
    editGiftsButton.click();
  }  
}

hideShowGiftError = (arr) => {
  $('.cart__item__property-prodcheck span').each(function() {
      var valProperty = $(this).text().trim().replaceAll(/[\s\n]+/g, '');
      var newArr = arr.map(function(item) {
        return item.replace(/\s+/g, '');
      });

      if (temp != 1) {
        if (newArr.indexOf(valProperty) !== -1) {
          var temp = 0;
          // console.log(valProperty + " exists in the array.");
        } else {
          var temp = 1;
            // console.log(valProperty + " does not exist in the array.");
        }
      }

      if (temp == 1) {
        renderGiftBoxMismatch();
      }

  }); 
}

renderGiftBoxMismatch = () => {

  var giftBoxMismatchElement = $('.gift-wrap__box-mismatch--message')[0];
  if (giftBoxMismatchElement == undefined) {
      var targetElement = $('.cart__inner .cart__checkout');
      var giftBoxMismatchPlaceholder = `
          <span class="gift-wrap__box-mismatch--message">
              <span class="gift-wrap__box-mismatch--message__icon">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z" stroke="#C20000" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M9 6V9" stroke="#C20000" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M9 12H9.00875" stroke="#C20000" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
              </span>
              <span class="gift-wrap__box-mismatch--message__content">
                  Seems you have removed a giftbox item. <br>Would you like to <span class="gift-wrap__box-mismatch--message__edit" onclick="editGiftsLink()">edit your gift?</span>
              </span>
          </span>
      `
      targetElement.parent().append(giftBoxMismatchPlaceholder);
  }
}

checkGiftWrapCurr = () => {

  var div_gwrap = $('.isNotGift')[0];

  if (div_gwrap == undefined) {
    $('#main_cart_packaging').hide();
  } 

    if ($('.isGift').length > 0) {
      $('#giftwrap_2').addClass('d-none');
      $('#giftwrap_1').removeClass('d-none');
      $('.gift-wrap__success ').removeClass('d-none');
    }else{
      var giftBoxMismatchElement = $('.gift-wrap__box-mismatch--message')[0];
      if (giftBoxMismatchElement){giftBoxMismatchElement.remove();}
      $('#giftwrap_2').removeClass('d-none'); 
      $('#giftwrap_1').addClass('d-none');
      $('.gift-wrap__success ').addClass('d-none');  
    }
}

minusQty = (evt) => {
  
  var $val = parseInt($(evt).parent('.gift-quantity').find('#select_giftwrap').val());
  var $giftPrice = parseInt($('#_giftprice').attr('data-price'));
  var newP = $giftPrice;
  var $newVal = $val - 1;

  if ($val != 1){
    $('#select_giftwrap').val($newVal);
    newP =  ($('#select_giftwrap').val() * $giftPrice) / 100;
    $('#_giftprice .money').text(newP.toFixed(2));
  }

}

plusQty = (evt) => {
  
  var $val = parseInt($(evt).parent('.gift-quantity').find('#select_giftwrap').val());
  var $giftPrice = parseInt($('#_giftprice').attr('data-price'));
  var newP = $giftPrice;
  var $maxQty = parseInt($(evt).attr('gift-maxQty'));
  var $newVal = $val + 1;

  if ($val < $maxQty){
    $('#select_giftwrap').val($newVal);
    newP =  ($('#select_giftwrap').val() * $giftPrice) / 100;
    $('#_giftprice .money').text(newP.toFixed(2));
  }

}

// Initiates with the number of giftwrap bixes selected
initArray = (arrayLimit) => {
  var index;
  addCartArray = [];
  addCartMessageArray = []; 
  editCartArray = [];
  var _ = parseInt(arrayLimit);

  addCartMessageArray = new Array(_);
  for (index = 0; index < arrayLimit; index += 1) {
    addCartArray.push([]);
    editCartArray.push([]);
  }
}

constructHTML = (i, num) => {
  if (num !=0) {
    var exist_num = i;
    i = num;
  }

    var img = $('.giftwrap-product-item__image img').attr('src');

    var $html = `
        <div class="gift-wrap__message--wrapper">
          <div class="gift-wrap__message--image">
              <img src="${img}" />
         </div>  
          <div class="gift-wrap__message--content">
              <span>Gift ${i}</span>
              <label>Complimentary gift message</label>
              <textarea maxlength="250" class="giftWrap_message_${i} gift_textarea" id="giftWrap_message_${i}" row="4"></textarea>
          </div>
       </div>
    `

  return $html;
}


var stepThreeHeading = `<div class="giftwrap_3__box-step">Which gift box is it for?  (Step 3 of 3)</div>`

function insertStepThreeTitle(targetElems) {
    targetElems[targetElems.length - 1].insertAdjacentHTML('afterend', stepThreeHeading);
}

togglePersonalisedGiftWrap = (evt) =>{ 
      $('#personaliseGiftBtn').addClass('d-none');
      $('#giftwrap_2').addClass('d-none');

      var $this = $(evt);

      number_of_gift_wrap = parseInt($('#select_giftwrap').val());


      if($this.hasClass('edit_btn')){
        number_of_gift_wrap = $('.isGift').length;
      }

      __qtys =0;
      if ($('.isGift').length > 0 ) {
        $('.isGift').each(function(index,evt) {
          __qtys +=  parseInt($(evt).find('input.cart__quantity-field').val());
        })
    
        number_of_gift_wrap = __qtys;
      }

      initArray(number_of_gift_wrap);
      number_of_gift_wrap = parseInt(number_of_gift_wrap) + 1;

      for (var i = 1; i < number_of_gift_wrap; i++) {
        var _ = constructHTML(i, 0);
        $('#giftwrap_3').append(_);
        $('.giftwrap_3__message-step').removeClass('d-none');
        $('.giftwrap3__action').removeClass('d-none');
        $('#giftwrap_3').removeClass('d-none');
        
      }
      if ($this.hasClass('edit_btn')) {
        $('#giftwrap_1').addClass('d-none');
        $('#giftwrap_all').addClass('d-none');
        $('#giftwrap_3').removeClass('d-none').fadeIn();
      }
      else{
        $('#giftwrap_3').removeClass('d-none').fadeIn();
      }


      var dropdown = constructDropdownHtml(number_of_gift_wrap);
      $('.cart__items').children().each(function(i){
        if ($(this).hasClass('isNotGift')) {
          var cloned = $(this).clone();
          var quantity = cloned.find('input.cart__quantity-field');
          var quantity_val = 0;
          if (quantity) {
            quantity_val = parseInt(quantity.val());
          }
    
          // remove unused elements;
          cloned.find('.cart__item__content .cart__price').remove();
          cloned.find('.cart__item__content .cart__quantity').remove();
          cloned.find('.cart__item__content .cart__item__remove').remove();
    
          cloned.append(dropdown);
          cloned.find('.box_dropdown').attr('id', 'gift_dropdown_'+i);
          cloned.find('.box_dropdown').attr('data-number', i);
          $('#giftwrap_3').append(cloned);
          for (var count = 1; count < quantity_val; count++) {
            var _c = cloned.clone();
            $('#giftwrap_3').append(_c);
          }
    
        }
    
        // Add button at the end of appending all new div
    
      })

      let giftwrapMessageWrappers = document.querySelectorAll('.gift-wrap__message--wrapper');
      insertStepThreeTitle(giftwrapMessageWrappers);


      /* Limit Gift box items module - start */
    const giftBoxHome = document.getElementById('main_cart_packaging');
    let giftBoxSelectElements = giftBoxHome.querySelectorAll('#giftwrap_3 select.box_dropdown');

    function handleGiftBoxState(giftBoxCount) {
        let giftBoxesQuantities = {};

        for (let i = 1; i < giftBoxCount; i++) {
            giftBoxesQuantities[`Box ${i}`] = 0;
        }

        let updateState = function(domSelection) {
            let stateKeys = Object.keys(giftBoxesQuantities);
            stateKeys.forEach(stateKey => {
                let boxQuantity = domSelection.filter(selection => stateKey === selection);
                giftBoxesQuantities[stateKey] = boxQuantity.length;
            });
            return giftBoxesQuantities;
        }

        return updateState ;
    }

    function forceGiftBoxOptionLimit(optionKey) {
        giftBoxSelectElements.forEach(elem => {
            for (let j=0; j < elem.length; j++) {
                if (elem.options[j].text === optionKey) {
                  elem.options[j].setAttribute('disabled', 'disabled');
                  elem.options[j].classList.add('giftbox__limit');
                  $('.box_dropdown option:selected').removeAttr('disabled');
                }
            }
        });
    }

    function liftGiftBoxOptionLimit(optionKey) {
        giftBoxSelectElements.forEach(elem => {
            for (let j=0; j < elem.length; j++) {
                if (elem.options[j].text === optionKey) {
                    elem.options[j].removeAttribute('disabled');
                    elem.options[j].classList.remove('giftbox__limit');
                }
            }
        });
    }

    let giftBoxState = handleGiftBoxState(number_of_gift_wrap);

    giftBoxSelectElements.forEach(selectElem => {
        selectElem.addEventListener('change', evt => {
            let thisSelectedOptionIndex = evt.target.selectedIndex;
            let thisSelectValue = evt.target.options[evt.target.selectedIndex].text;
            let giftBoxSelection = [...giftBoxSelectElements].map(elem => elem.options[elem.selectedIndex].text);
            let giftBoxQuantities = giftBoxState(giftBoxSelection);

            for (const [key, value] of Object.entries(giftBoxQuantities)) {
                if (value >= 2) {
                    forceGiftBoxOptionLimit(key);
                }
                if (value < 2) {
                    liftGiftBoxOptionLimit(key);
                }
            }
        });
    });
    /* Limit Gift box items module - end */
  
      /* Limit Gift message module - start */
      let giftMessageElements = document.querySelectorAll('textarea[id^="giftWrap_message_"]');
      giftMessageElements.forEach((messageElement, index) => {
          let remainingCharactersPlaceholder = `
                                              <p class="gift-wrap-message__char-count">
                                                  <span>${messageElement.getAttribute("maxlength")}</span>/250
                                              </p>
                                              `
          let remainingCharactersPlaceholderFrag = document.createRange().createContextualFragment(remainingCharactersPlaceholder);
          messageElement.parentElement.append(remainingCharactersPlaceholderFrag);
          messageElement.addEventListener("input", evt => {
              let messageArea = evt.currentTarget;
              let maxCharacterCount = messageArea.getAttribute("maxlength");
              let characterCount = messageArea.value.length;
              let characterCountMessage = messageArea.parentElement.parentElement.querySelector('.gift-wrap-message__char-count span');
              remainingTextAreaCharacters = maxCharacterCount - characterCount;
              characterCountMessage.innerText = remainingTextAreaCharacters;
          });
      });
      /* Limit Gift message module - end */
      
}


// HTML construct at the dropdown level
constructDropdownHtml = (number) =>{
  var _t = `<div class="two columns omega"><select class="box_dropdown">`;
  for (var i = 0; i < number; i++) {
    if (i == 0) {
      _t += `<option value="${i}">No box</option>`;
    }
    else{
      _t += `<option value="${i}">Box ${i}</option>`;
    }
  }

  _t +=`</select></div>`

  return _t;
}

cancelStep = () => {
  $('#giftwrap_3').empty();
  $('.giftwrap_3__message-step').addClass('d-none');
  $('.giftwrap3__action').addClass('d-none');

  $('#giftwrap_2').removeClass('d-none');
  $('#personaliseGiftBtn').removeClass('d-none');

  if ($('.isGift').length > 0) {
    $('#giftwrap_2').addClass('d-none');
    $('#giftwrap_1').removeClass('d-none');
  };
}

// Add giftwrap function from step 3 where
cartJSAddMoreGift = () => {
  cartJSAddQuery(fixed_gift_id, 1); 
}

cartJSAddGift = () => {

  if ($('.isGift').length > 0) {
    isEdit = true;
  }

  if(isEdit){
    CartJS.removeItemById(fixed_gift_id);
  }
  var tim = 0;
  for (var i = 0; i < addCartArray.length; i++) {
    if (addCartArray[i].length > 0) {
      // Loop through all the product title belong specific giftbox
      var _object = {};
      for (var j = 0; j < addCartArray[i].length; j++) {
        // Check exist message
        if (addCartMessageArray[i]) {
          var _message = addCartMessageArray[i];
          _object['Message'] = _message;
        }

        // Setup product title;
        var object_title = "Product " + (j + 1);
        _object[object_title] = addCartArray[i][j];
      }

      CartJS.addItem(fixed_gift_id, 1, _object,
      {
        "success": function(data, textStatus, jqXHR) {
          tim+=1;
          if (tim == addCartArray.length) {
            location.reload();
          }
        },
        "error": function(jqXHR, textStatus, errorThrown) {
            console.log('Error: ' + errorThrown + '!');
        }
      });

    }
    else{

      var _obj = {};
      if (addCartMessageArray[i]) {
        _obj['Message'] = addCartMessageArray[i];
      }
      CartJS.addItem(fixed_gift_id, 1, _obj , {
        "success": function(data, textStatus, jqXHR) {
          tim+=1;
          if (tim == addCartArray.length) {
            location.reload();
          }
        }
      });

    }
  }
}
setupMessageAddArray = (indexing) => {
  var _n = parseInt(indexing) + 1;
  var _text = $('#giftWrap_message_'+_n).val();
  if (_text) {
    addCartMessageArray[indexing] = _text;
  }
}


getAppendedProductLineItemString = (element) => {
  var $target_div = element.parent().parent().find('.cart__item__title');
  var target_text = $target_div.text();

  var $target_div_var = element.parent().parent().find('.cart__item__selected-options span');
  var target_text_var = $target_div_var.text();

  var target_properties = target_text_var;

  if (target_properties) {
    target_properties = target_properties.replace(/^\s+|\s+$/gm,'');
    var new_string = target_text + ' - ' + target_properties;
  }
  else{
    var new_string = target_text;
  }

  return new_string;
}

addGiftWrap = () => {
  $('.box_dropdown').each(function(i, element){
    $this = $(element);
    setupAddArray($this, $this.val())
    setupMessageAddArray(i)
  })

  // Double check
  for (var i = 0; i < number_of_gift_wrap; i++) {
    setupMessageAddArray(i);
  }
  cartJSAddGift();
}

setupAddArray = ($this, $num) => {
  if ($num != 0) {
    $num = parseInt($num) - 1;

    var new_String = getAppendedProductLineItemString($this);
    addCartArray[$num].push(new_String);
  }
}


removeAllGiftWrap = () => {
  CartJS.removeItemById(fixed_gift_id);
  setTimeout(function(){
    location.reload();
  },1000)

}

editGiftWrap = (evt) => {
  togglePersonalisedGiftWrap(evt);
}

  